import * as angular from "angular";

export class SkillsRequests {

  /* @ngInject */
  constructor(private SkillsAPI, private $skills) {
  }

  getAll(ids?) {
    const api = this.SkillsAPI.actions.getAll;
    return this.$$call(api, {ids: ids}, {}, {});
  }

  createOne(skill) {
    const api = this.SkillsAPI.actions.createOne;
    return this.$$call(api, {}, skill, {});
  }

  updateOne(label) {
    const api = this.SkillsAPI.actions.updateOne;
    return this.$$call(api, {}, label, {id: label.id});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$skills().$call(_apiCall, _params, _data, _options);
  }

}
angular
  .module('bringoz.admin.skills')
  .service('skillsRequests', SkillsRequests);
